$(document).ready(function() {

   $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };



  var body = $('body');
  var langToggle = $('#lang-toggle');




    setTimeout(function() {
      $('.site-header').addClass('active');
          setTimeout(function() {
            $('.main-content').addClass('active');
          }, 300);
    }, 300);

  /* Click Events — Language Toggle */

  langToggle.click(function (evt) {

    if (body.hasClass('lang-en')){
      body.addClass('lang-fr').removeClass('lang-en');
      langToggle.text('FR');

    } else {
      body.addClass('lang-en').removeClass('lang-fr');
      langToggle.text('EN');
    }

    evt.preventDefault();
    return false;
  });


  /* Homepage Fade */

  // Lazy Load Images

  $('.block, .shopify-section').each(function(i){
    $('#shopify-section-announcement_bar, #shopify-section-search-bar, #shopify-section-drawer-mobile').addClass('active');
    if ($(this).isInViewport()) {
      var target = $(this);
      console.log(target)
          setTimeout(function() {
            target.addClass('active');
          }, 250);
    }
  });

      $(window).on('resize scroll', function() {
        $('.block, .shopify-section').each(function(i){
          if ($(this).isInViewport()) {
            var target = $(this);
                setTimeout(function() {
                  target.addClass('active');
                }, 250);
          }
        });
      });




  /* Tabs on Product Detail Page */

  $(".desc-headings .grid__item").click(function (evt) {
    $(this).addClass('active').siblings().removeClass('active');

    var target = $(this).attr('data-reveal');

    $('.desc-detail').find('.'+target).show().siblings().hide();
    evt.preventDefault();
    return false;
  });




  // Product Page

  if (body.hasClass('template-product')){

    // Product Carousel

    $('.slick').slick({
      autoplay: true,
      dots: false,
      arrows: true,
      fade: true,
      speed: 1500
    });




    // Fixed the left side

    if ($('#pre-footer').isInViewport()) {
        $('.product-desc').addClass('unstuck');
    } else {
        $('.product-desc').removeClass('unstuck');
    }

    $(window).on('resize scroll', function() {
      if ($('#pre-footer').isInViewport()) {
              $('.product-desc').addClass('unstuck');
          } else {
              $('.product-desc').removeClass('unstuck');
          }
    });

  }


  $(".yoga-link").click(function (evt) {
    $(this).parent().addClass('active').siblings().removeClass('active');
    var target = $(this).data('url');
    $('#yoga-vid').attr('src',target);

    evt.preventDefault();
    return false;
  });

  $( ".jump-nav li" ).hover(
    function() {
      $(this).siblings().css('opacity','0.25').css('mix-blend-mode','multiply');
    }, function() {
      $(this).siblings().css('opacity','').css('mix-blend-mode','');
    }
  );

  $(".jump-nav li").click(function (evt) {
    $(this).addClass('active').siblings().removeClass('active');
    evt.preventDefault();
    return false;
  });


  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - 88
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });

});
